import { MockMethod } from 'vite-plugin-mock'
import { SUCCESS_CODE } from '@/constants'

const timeout = 1000

const adminList = [
  {
    path: '/home',
    component: '#',
    redirect: '/home/index',
    name: 'Home',
    meta: {},
    children: [
      {
        path: 'index',
        name: 'HomeIndex',
        component: 'views/Home/Home',
        meta: {
          icon: 'carbon:ai-generate',
          title: 'router.agent'
        }
      },
      {
        path: 'add',
        name: 'HomeAdd',
        component: 'views/Home/AddAgent',
        meta: {
          hidden: true,
          icon: 'carbon:ai-generate',
          title: 'router.agent'
        }
      },
      {
        path: 'edit',
        name: 'HomeEdit',
        component: 'views/Home/AddAgent',
        meta: {
          hidden: true,
          icon: 'carbon:ai-generate',
          title: 'router.agent'
        }
      }
    ]
  },
  /* 目录管理 */
  {
    path: '/test',
    component: '#',
    redirect: '/test/index',
    name: 'Test',
    meta: {},
    children: [
      {
        path: 'contents-manage',
        name: 'ContentsManage',
        component: 'views/Test/ContentsManage',
        meta: {
          icon: 'carbon:light',
          title: 'router.test'
        }
      },
      {
        // path: 'tags-manage',
        // name: 'TagsManage',
        // component: 'views/Test/TagsManage',
        path: 'add-tags',
        name: 'AddTags',
        component: 'views/Test/AddTags',
        meta: {
          icon: 'carbon:light',
          title: 'router.test'
        }
      }
    ]
  },
  {
    path: '/carousel',
    component: '#',
    redirect: '/carousel/index',
    name: 'Carousel',
    meta: {},
    children: [
      {
        path: 'index',
        name: 'CarouselIndex',
        component: 'views/Carousel/Carousel',
        meta: {
          icon: 'carbon:light',
          title: 'router.carousel'
        }
      },
      {
        path: 'create',
        name: 'CarouselCreateForm',
        component: 'views/Carousel/CarouselForm',
        meta: {
          hidden: true,
          activeMenu: '/carousel/index',
          title: 'router.carouselCreateForm'
        }
      },
      {
        path: 'edit/:id',
        name: 'CarouselEditForm',
        component: 'views/Carousel/CarouselForm',
        meta: {
          hidden: true,
          activeMenu: '/carousel/index',
          title: 'router.carouselEditForm'
        }
      }
    ]
  },
  {
    path: '/agent-config',
    component: '#',
    redirect: '/agent-config/index',
    name: 'AgentConfig',
    meta: {},
    children: [
      {
        path: 'index',
        name: 'AgentConfigIndex',
        component: 'views/AgentConfig/AgentConfig',
        meta: {
          icon: 'carbon:chat',
          title: 'router.agentConfig'
        }
      }
    ]
  }
]

export default [
  // 列表接口
  {
    url: '/mock/role/list',
    method: 'get',
    timeout,
    response: () => {
      return {
        code: SUCCESS_CODE,
        data: adminList
      }
    }
  }
] as MockMethod[]
